import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sjh",
  "use": "icon-sjh-usage",
  "viewBox": "0 0 11 13.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 13.6\" id=\"icon-sjh\"><title>资源 2</title><g id=\"icon-sjh_图层_2\" data-name=\"图层 2\"><g id=\"icon-sjh_图层_1-2\" data-name=\"图层 1\"><path d=\"M9.5,13.6h-8A1.5,1.5,0,0,1,0,12.1V1.5A1.5,1.5,0,0,1,1.5,0h8A1.5,1.5,0,0,1,11,1.5V12.1A1.5,1.5,0,0,1,9.5,13.6ZM1.5,1a.5.5,0,0,0-.5.5V12.1a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5V1.5A.5.5,0,0,0,9.5,1Z\" /><rect x=\"0.6\" y=\"8.7\" width=\"9.8\" height=\"1\" /><path d=\"M6.8,11.6H4.2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H6.8a.5.5,0,0,1,.5.5A.5.5,0,0,1,6.8,11.6Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sjh.svg
// module id = MmXq
// module chunks = 75